module.exports = __webpack_public_path__ + "img/logo-viola.be4fd941.png";